<div class="list-wrapper">
  <kgrid
    *ngIf="dataList && columns && columns.length > 0"
    [label]="label"
    [name]="apiName"
    [columns]="columns"
    [areaName]="areaName"
    [isEdit]="false"
    [isDelete]="false"
    [isAdd]="false"
    [isModal]="true"
    [dataList]="dataList"
    [actions]="actions"
    (onRefreshData)="getVoucher()"
    reportName="CreateClosingJournalVoucherList"
    pathPreFix="ACC"
    [inputEditorform]="inputEditorform">
  </kgrid>
</div>
